<ng-container *ngIf="isMobileDisplay">
    <div class="block-wrapper" [class.selected]="isSelected" [class.mobile]="isMobileDisplay">
        <div class="content-wrapper">
            <div class="session-exercice session-exercice-duration">
                <div class="header">
                    <div fxLayout="row" fxLayoutAlign="center center" >
                        <div class="title">
                            {{data.data.exercice.exercice.name}}
                        </div>
                        <div>
                            <!-- <button mat-icon-button matTooltip="{{ 'Stopwatch' | translate }}">
                                <mat-icon>stopwatch</mat-icon>
                            </button> -->
                            <app-chat-share [organization]="organization" [sharable]="data.data.exercice.exercice">
                                <button mat-icon-button matTooltip="{{ 'Share' | translate }}">
                                    <mat-icon>share</mat-icon>
                                </button>
                            </app-chat-share>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <div class="accents">
                        <div class="accent" *ngFor="let category of data.data.exercice.categories">
                            <exercice-category-thumbnail *ngIf="category !== null" [data]="category" [isMobileDisplay]="isMobileDisplay" [showAsTag]="true"></exercice-category-thumbnail>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <div class="media" *ngIf="data.data.exercice.exerciceImage || data.data.exercice.exercice.video_path || data.data.exercice.exercice.video_url">
                        <div class="image">
                            <img *ngIf="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" [src]="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" />
                        </div>

                        <exercices-video-button *ngIf="data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url"
                                                class="play-video-button"
                                                [exercice]="data.data.exercice.exercice">
                        </exercices-video-button>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <div class="description">
                        {{ data.data.exercice.exercice.description }}
                    </div>
                </div>

                <!-- <div class="summary">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxFlex="50" class="item">
                            <div class="title">{{ 'seriePlaceholder' | translate }}</div>
                            <div class="value">{{ data.data.sessionItemExercice.nbRepeat }}x</div>
                        </div>
                        <div fxFlex="50" class="item">
                            <div class="title">{{ 'repetitionDurationPlaceholder' | translate }}</div>
                            <div class="value">{{ _duration | durationVerbose:'seconds' }}</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxFlex="50" class="item">
                            <div class="title">{{ 'restTimePlaceholderAlt' | translate }}</div>
                            <div class="value">{{ data.data.sessionItemExercice.restTime | durationVerbose:'seconds' }}</div>
                        </div>
                        <div fxFlex="50" class="item">
                            <div>
                                <button class="stopwatch-open-button" (click)="openStopwatch.emit(data.data)"><img src="../../../../assets/img/chrono.svg" alt=""></button>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="summary">
                    <div style="display:flex; border-bottom: 1px solid #ccc;">
                        <div style="display: flex; align-items:center; justify-content: center; flex-direction: column; width: 50%; text-align: center; border-right: 1px solid #ccc; padding: 15px 5px;">
                            <div class="title" style="font-size: 12px; font-weight: 400;">{{ 'seriePlaceholder' | translate }}</div>
                            <div class="value" style="font-size: 20px; font-weight: 600;">{{ data.data.sessionItemExercice.nbRepeat }}x</div>
                        </div>
                        <div style="display: flex; align-items:center; justify-content: center; flex-direction: column; width: 50%; text-align: center; padding: 15px 5px;">
                            <div class="title" style="font-size: 12px; font-weight: 400;">{{ 'repetitionDurationPlaceholder' | translate }}</div>
                            <div class="value" style="font-size: 20px; font-weight: 600;">{{ _duration??0 | durationVerbose:'seconds' }}</div>
                        </div>
                    </div>
                    <div style="display:flex">
                        <div style="display: flex; align-items:center; justify-content: center; flex-direction: column; width: 50%; text-align: center; border-right: 1px solid #ccc; padding: 15px 5px;">
                            <div class="title" style="font-size: 12px; font-weight: 400;">{{ 'restTimePlaceholderAlt' | translate }}</div>
                            <div class="value" style="font-size: 20px; font-weight: 600;">{{ data.data.sessionItemExercice.restTime | durationVerbose:'seconds' }}</div>
                        </div>
                        <div style="display: flex; align-items:center; justify-content: center; flex-direction: column; width: 50%; text-align: center; padding: 15px 5px;">
                            <button class="stopwatch-open-button" (click)="openStopwatch.emit(data.data)">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="68.217" height="68.217" viewBox="0 0 68.217 68.217">
                                    <defs>
                                        <filter id="Ellipse_134" x="0" y="0" width="68.217" height="68.217"
                                            filterUnits="userSpaceOnUse">
                                            <feOffset input="SourceAlpha" />
                                            <feGaussianBlur stdDeviation="3" result="blur" />
                                            <feFlood flood-opacity="0.161" />
                                            <feComposite operator="in" in2="blur" />
                                            <feComposite in="SourceGraphic" />
                                        </filter>
                                    </defs>
                                    <g id="Groupe_3602" data-name="Groupe 3602" transform="translate(-42.375 -787.892)">
                                        <g transform="matrix(1, 0, 0, 1, 42.38, 787.89)" filter="url(#Ellipse_134)">
                                            <circle id="Ellipse_134-2" data-name="Ellipse 134" cx="25.108" cy="25.108"
                                                r="25.108" transform="translate(9 9)" fill="#c29d4d" />
                                        </g>
                                        <g id="chronometer" transform="translate(18.65 808.449)">
                                            <g id="_x31_2_42_" transform="translate(46.909)">
                                                <g id="Groupe_3598" data-name="Groupe 3598" transform="translate(0)">
                                                    <path [class.red-path]="stopwatchSelected" id="red-path" data-name="Tracé 1451"
                                                        d="M242.415,161.516h-.025v7.273h7.2c0-.034,0-.067,0-.1A7.173,7.173,0,0,0,242.415,161.516Z"
                                                        transform="translate(-231.445 -152.473)" fill="#fff" />
                                                    <rect [class.red-path]="stopwatchSelected" id="red-path"
                                                        data-name="Rectangle 1068" width="1.26" height="1.821"
                                                        transform="translate(10.315 21.912)" fill="#fff" />
                                                    <rect [class.red-path]="stopwatchSelected" id="red-path"
                                                        data-name="Rectangle 1069" width="1.821" height="1.232"
                                                        transform="translate(3.931 15.456)" fill="#fff" />
                                                    <path [class.red-path]="stopwatchSelected" id="red-path" data-name="Tracé 1452"
                                                        d="M65.8,8.711l1.212-1.278a.84.84,0,0,0-.032-1.188l-1.017-.964a.84.84,0,0,0-1.188.032L63.39,6.775a10.851,10.851,0,0,0-3.6-1.346V3.642H61.44a.84.84,0,0,0,.84-.84V.84A.84.84,0,0,0,61.44,0H54.227a.84.84,0,0,0-.84.84V2.8a.84.84,0,0,0,.84.84h1.628V5.433a10.851,10.851,0,0,0-3.646,1.382l-.025-.026L50.608,5.3a.84.84,0,0,0-1.188.032l-.964,1.017a.84.84,0,0,0,.032,1.188L49.8,8.779a10.924,10.924,0,1,0,16-.068Zm-7.967,16.43A8.965,8.965,0,1,1,66.8,16.177,8.975,8.975,0,0,1,57.833,25.142Z"
                                                        transform="translate(-46.909)" fill="#fff" />
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div *ngIf="data.data.sessionItemExercice.comment" class="comment-container">
                    <div class="comment">{{ data.data.sessionItemExercice.comment }}</div>
                </div>

            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!isMobileDisplay">
    <div class="block-wrapper" [class.selected]="isSelected">
        <div class="content-wrapper">
            <div class="session-exercice session-exercice-duration">
              <div class="header" *ngIf="!basicDisplay">
                    <div fxLayout="row" fxLayoutAlign="space-between center" >
                        <div class="title">
                            {{data.data.exercice.exercice.name}}
                        </div>
                        <div *ngIf="isEditable">
                            <button mat-icon-button *ngIf="!itsTheFirst"
                                    [matTooltip]="'Move_up' | translate"
                                    (click)="moveup(data)">
                                <mat-icon>arrow_upward</mat-icon>
                            </button>
                            <button mat-icon-button *ngIf="!itsTheLast"
                                    [matTooltip]="'Move_down' | translate"
                                    (click)="movedown(data)">
                                <mat-icon>arrow_downward</mat-icon>
                            </button>

                            <button mat-icon-button [matMenuTriggerFor]="menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="duplicate(data)">
                                    <mat-icon>filter_none</mat-icon>
                                    <span>{{ 'Duplicate' | translate}}</span>
                                </button>
                                <button mat-menu-item (click)="personalized(data)">
                                    <mat-icon>edit_outlined</mat-icon>
                                    <span>{{ 'Personalize' | translate}}</span>
                                </button>
                                <button mat-menu-item (click)="duplicateAsModel(data)">
                                    <mat-icon>book</mat-icon>
                                    <span>{{ 'Make_a_model' | translate}}</span>
                                </button>
                                <button mat-menu-item (click)="delete(data)">
                                    <mat-icon>delete_outline</mat-icon>
                                    <span>{{ 'Delete' | translate}}</span>
                                </button>
                            </mat-menu>
                        </div>

                        <div *ngIf="!isEditable">
                            <button mat-icon-button
                                    [matTooltip]="(data.isCollapsed ? 'Open' : 'Close') | translate "
                                    (click)="data.isCollapsed = !data.isCollapsed">
                                <mat-icon>{{ data.isCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                            </button>
                            <app-chat-share [organization]="organization" [sharable]="data.data.exercice.exercice">
                                <button mat-icon-button matTooltip="{{ 'Share' | translate }}">
                                    <mat-icon>share</mat-icon>
                                </button>
                            </app-chat-share>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between start">
                    <div>
                      <div *ngIf="!basicDisplay">
                            <div class="accents">
                                <div class="accent" *ngFor="let category of data.data.exercice.categories">
                                    <exercice-category-thumbnail *ngIf="category !== null" [data]="category" [showAsTag]="true"></exercice-category-thumbnail>
                                </div>
                            </div>
                            <ng-container *ngIf="isMobileDisplay">
                                <div class="media-mobile" *ngIf="data.data.exercice.exerciceImage || data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url">
                                    <img *ngIf="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" [src]="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" />

                                    <ng-container *ngIf="isMobileDisplay">
                                        <exercices-video-button *ngIf="data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url"
                                                                class="play-video-button"
                                                                [exercice]="data.data.exercice.exercice">
                                        </exercices-video-button>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <div class="description">
                                {{ data.data.exercice.exercice.description }}
                            </div>
                        </div>

                        <ng-container *ngIf="!data.isCollapsed">
                            <div *ngIf="!isEditable" class="summary">
                                <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px">

                                    <div *ngIf="data.data.sessionItemExercice.nbRepeat"
                                         class="item">
                                        <div class="title">{{ 'seriePlaceholder' | translate }}</div>
                                        <div>{{ data.data.sessionItemExercice.nbRepeat }}x</div>
                                    </div>
                                    <div *ngIf="_duration"
                                         class="item">
                                        <div class="title">{{ 'repetitionDurationPlaceholder' | translate }}</div>
                                        <div>{{ _duration | durationVerbose:'seconds' }}</div>
                                    </div>
                                    <div *ngIf="data.data.sessionItemExercice.restTime"
                                         class="item">
                                        <div class="title">{{ 'restTimePlaceholderAlt' | translate }}</div>
                                        <div>{{ data.data.sessionItemExercice.restTime | durationVerbose:'seconds' }}</div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <div class="total-duration" [class.bold]="isEditable">
                            <div class="title" *ngIf="!isEditable">{{ 'totalTime' | translate }}</div>
                            {{ totalDuration | durationVerbose:'seconds' }}
                        </div>
                    </div>
                    <ng-container *ngIf="!isMobileDisplay && !basicDisplay">
                        <div class="media" *ngIf="data.data.exercice.exerciceImage || data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url">
                            <img *ngIf="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" [src]="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" />

                            <exercices-video-button *ngIf="data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url"
                                                    class="play-video-button"
                                                    [exercice]="data.data.exercice.exercice"
                                                    [iconOnly]="true"
                            >
                            </exercices-video-button>
                        </div>
                    </ng-container>

                    <!--<div class="media" *ngIf="data.data.exercice.exerciceImage || data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url">
                        <img *ngIf="data.data.exercice.exerciceImage" [src]="data.data.exercice.exerciceImage" />
                        <exercices-video-button *ngIf="data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url"
                                                class="play-video-button"
                                                [exercice]="data.data.exercice.exercice">
                        </exercices-video-button>
                    </div>-->
                </div>

                <ng-container *ngIf="!isEditable">
                    <div *ngIf="data.data.sessionItemExercice.comment" class="comment-container">
                        <div class="comment">{{ data.data.sessionItemExercice.comment }}</div>
                    </div>
                </ng-container>
            </div>

        </div>
        <div class="drag-handle" ngxDragHandle *ngIf="isEditable">
            <mat-icon>drag_indicator</mat-icon>
        </div>
    </div>
</ng-container>
